export default __webpack_public_path__ + "images/6e8d73ef3029d8927af4cd82bb2884a5-maestro@2x.png";